import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  sentinelOneAlert: {},
  updateSentinelOneAlert: {},
  influxSentinelOneAlert: {},
  sentinelOneEmailToClient: {},
  isLoading: false,
  error: null,
};

const sentinelOneSlice = createSlice({
  name: 'sentinelOne',
  initialState,
  reducers: {
    start: (state, action) => {
      state.error = null;
      state.isLoading = true;
    },
    setReducerError: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    setSentinelOneAlert: (state, action) => {
      state.sentinelOneAlert = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setUpdateSentinelOneAlert: (state, action) => {
      state.updateSentinelOneAlert = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setInfluxSentinelOneAlert: (state, action) => {
      state.influxSentinelOneAlert = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setSentinelOneAlertDescription: (state, action) => {
      state.sentinelOneAlertDescription = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setSentinelOneEmailAlertToClient: (state, action) => {
      state.sentinelOneEmailToClient = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setResetSentinelOne: () => {
      return initialState;
    },
  },
});

export const {
  start,
  setReducerError,
  setSentinelOneAlert,
  setUpdateSentinelOneAlert,
  setInfluxSentinelOneAlert,
  setSentinelOneAlertDescription,
  setSentinelOneEmailAlertToClient,
  setResetSentinelOne,
} = sentinelOneSlice.actions;

export default sentinelOneSlice.reducer;
